<div class="campo-foto-dashboard">
  <div class="miniatura">
    @if (url) {
      <app-foto-remota [url]="url" [alt]="titulo" className="miniatura-img" />
    } @else {
      <div class="miniatura-vacia">Sin foto</div>
    }
  </div>

  @if (puedeEditar) {
    <div class="acciones">
      <label class="boton boton-subir" [class.deshabilitado]="subiendo()">
        {{ url ? 'Reemplazar' : 'Subir' }}
        <input type="file" accept="image/*" (change)="alElegirArchivo($event)" [disabled]="subiendo()" hidden />
      </label>

      @if (url) {
        <button type="button" class="boton boton-eliminar" [disabled]="subiendo()" (click)="abrirConfirmarEliminar()" aria-label="Eliminar foto">
          🗑
        </button>
      }

      @if (hayAnterior()) {
        <button type="button" class="boton boton-quitar" [disabled]="subiendo()" (click)="abrirPreguntaQuitar()" aria-label="Quitar reemplazo">
          ✕
        </button>
      }
    </div>

    @if (subiendo()) {
      <p class="estado">Guardando…</p>
    }
  }

  @if (error(); as msg) {
    <div class="toast-error" role="alert">{{ msg }}</div>
  }
</div>

@if (mostrarConfirmarEliminar()) {
  <div class="dialogo-overlay" (click)="cerrarConfirmarEliminar()">
    <div class="dialogo" (click)="$event.stopPropagation()">
      <p>¿Seguro que quieres eliminar esta foto?</p>
      <div class="dialogo-botones">
        <button type="button" (click)="cerrarConfirmarEliminar()">Cancelar</button>
        <button type="button" class="boton-peligro" (click)="confirmarEliminar()">Eliminar</button>
      </div>
    </div>
  </div>
}

@if (mostrarPreguntaQuitar()) {
  <div class="dialogo-overlay" (click)="cerrarPreguntaQuitar()">
    <div class="dialogo" (click)="$event.stopPropagation()">
      <p>¿Quieres dejar vacío este campo o restaurar la foto anterior?</p>
      <div class="dialogo-botones">
        <button type="button" (click)="cerrarPreguntaQuitar()">Cancelar</button>
        <button type="button" (click)="resolverQuitar('vaciar')">Dejar vacío</button>
        <button type="button" class="boton-primario" (click)="resolverQuitar('restaurar')">Restaurar anterior</button>
      </div>
    </div>
  </div>
}
